import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-advertise-home',
  templateUrl: './advertise-home.component.html',
  styleUrls: ['./advertise-home.component.css']
})
export class AdvertiseHomeComponent implements OnInit {


  @Input() img_url_en : string = '';
  @Input() img_url_ar : string = '';
  @Input() img_url_mobile_en : string = '';
  @Input() img_url_mobile_ar : string = '';
  @Input() srcPage : string = '';
  @ViewChild('adver_modal', { static : true }) adver_modal : ElementRef;


  lang : string = this.cookie_s.get('lang') || 'en';
  modal_obj : NgbModalRef;







  constructor(
    private r : Router,
    private modalService: NgbModal,
    private cookie_s: CookieService
  ) { }


  ngOnInit(): void
  {
    // open modal
    this.check_if_allowed();

  }




  check_if_allowed()
  {

    // write a condition here later, if there this is used in multiple places
    if ( !this.cookie_s.get('poster_visited') )
    {
      this.open_modal(this.adver_modal);
    }


  }


  open_modal(content : ElementRef)
  {
		this.modal_obj = this.modalService.open(content , { centered : true , keyboard : true , size : 'lg' , animation : true , beforeDismiss : this.before_exit_poster , backdrop: 'static' });
	}


  close_poster()
  {
    this.cookie_s.set("poster_visited", "true", undefined, "/");
    this.modal_obj.dismiss();
  }



  before_exit_poster()
  {
    // write action to do before closing modal
    // this.cookie_s.set("poster_visited", "true", undefined, "/");

    return true;
  }



  exit_poster()
  {

    // write action to do when close action is made for modal
    this.modal_obj.dismiss();

  }





}
